// extracted by mini-css-extract-plugin
module.exports = {"layout":"_3aL3hfsgzS1-ia9Uj7snp6"};